import classNames from 'classnames';
import React from 'react';
import {
  Col,
  Row
} from 'react-bootstrap';

const NotificationMessage = ({ message }) => (
  <Row className='no-gutter submissionMessage'>
    <Col xs={12}>
      <div
        className={classNames('warning', 'yellow')}>
        {message}
      </div>
    </Col>
  </Row>
);

export default NotificationMessage;



// WEBPACK FOOTER //
// ./src/containers/components/notification-message.js